import type { ThemeOptions } from '@mui/material';
import { createTheme, css, responsiveFontSizes } from '@mui/material';
import { deDE } from '@mui/material/locale';
import '@fontsource/roboto/latin-300.css';
import '@fontsource/roboto/latin-400.css';
import '@fontsource/roboto/latin-500.css';
import '@fontsource/roboto/latin-700.css';
import '@fontsource/barlow/latin-300.css';
import '@fontsource/barlow/latin-400.css';
import '@fontsource/barlow/latin-500.css';
import '@fontsource/barlow/latin-700.css';

let baseTheme = createTheme(
  {
    palette: {
      primary: {
        main: '#FFD36C',
        dark: '#FBB243',
        contrastText: '#000000',
      },
      secondary: {
        main: '#0046AA',
        contrastText: '#FFFFFF',
      },
      error: {
        main: '#FF5A5A',
      },
      text: {
        secondary: 'rgba(0, 0, 0, 0.7)',
      },
    },
    typography: {
      fontFamily: 'Barlow, Helvetica, Arial, sans-serif',
      fontSize: 16,
      h5: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 22,
        lineHeight: 1.27,
      },
      h6: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 20,
        lineHeight: 1.57,
        color: '#000000',
      },
      subtitle2: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: 1.57,
        color: '#000000',
      },
      body2: {
        fontFamily: 'Barlow, Helvetica, Arial, sans-serif',
        fontSize: 14,
        lineHeight: 1.43,
        fontWeight: 400,
      },

      button: {
        fontFamily: 'Barlow, Helvetica, Arial, sans-serif',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '26px',
        letterSpacing: '0.46px',
        fontFeatureSettings: "'liga' off, 'clig' off",
        textTransform: 'none',
      },
    },
    shape: {
      borderRadius: 8,
    },
  },
  deDE,
);

baseTheme = createTheme(baseTheme, {
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: '#000000',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: css`
          border-radius: 8px;
          background-color: ${baseTheme.palette.common.white};
          & .MuiOutlinedInput-notchedOutline {
            border: none;
          }
        `,
        sizeSmall: css`
          height: 40px;
        `,
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: css`
          font-family: 'Barlow', 'Helvetica', 'Arial', sans-serif;
        `,
        '#root': css`
          height: 100%;
        `,
        '.maplibregl-popup-content': css`
          padding: 0;
          border-radius: 0 8px 8px 8px;
          background-color: ${baseTheme.palette.common.white};
          box-shadow: ${baseTheme.shadows[5]};
        `,
      },
    },
  },
} as ThemeOptions);

export const theme = responsiveFontSizes(baseTheme);
